module.exports = __webpack_public_path__ + "static/img/rank_294.220bfa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_294.png
// module id = xFuk
// module chunks = 0